<template>
  <div>
    <headTop></headTop>
    <div class="onlinemapping">
      <span class="mapping">在线审图</span>
      <span class="apply">— 在线申请</span>
      <div @click="chargeShow">收费标准</div>
    </div>
    <section ref="online_contain" class="online_contain">

      <!-- form 表单 -->
      <div class="form">
        <div class="form_list">
          <div class="lable">单位名称</div>
          <div class="text">
            <input type="text" name id placeholder="输入单位名称" v-model="EntityName" />
          </div>
        </div>
        <div class="form_list">
          <div class="lable">项目名称</div>
          <div class="text">
            <input type="text" placeholder="输入项目名称" v-model="projectName" />
          </div>
        </div>
        <div class="form_list">
          <div class="lable">地址信息</div>
          <div class="text" @click="setadress">
            <input type="text" placeholder="请选择" readonly="readonly" v-model="projectAdress"
              @focus="loseblur($event)" />
            <div class="arrow"></div>
          </div>
        </div>
        <div class="adress">
          <div class="detial_adress">详细地址</div>
          <div class="adress_content">
            <textarea placeholder="如道路、门牌号、小区、楼栋号、单 元室等" v-model="inforDetial"></textarea>
          </div>
        </div>
        <div class="form_list">
          <div class="lable">项目场所</div>
          <div class="text" @click="setsite">
            <input type="text" placeholder="请选择" readonly="readonly" v-model="projectSite" @focus="loseblur($event)" />
            <div class="arrow"></div>
          </div>
        </div>
        <div class="form_list">
          <div class="lable">项目类别</div>
          <div class="text" @click="project">
            <input type="text" placeholder="请选择" readonly="readonly" v-model="classification"
              @focus="loseblur($event)" />
            <div class="arrow"></div>
          </div>
        </div>
        <div class="area">
          <div class="area-box">
            <div class="title">项目面积</div>
            <div class="content">
              <input type="number" placeholder="请填写项目面积" v-model.lazy="projectArea" /> m²
            </div>
          </div>
          <div class="area-content">
            <p>
              <i class="GT">i</i>当您选择办公场所项目且面积大于
              <span>2000㎡</span>时或当您选择商业场所项目 且面积大于
              <span>1000㎡</span>时，平台需评估计价；
            </p>
            <div v-show="area">
              审图预算：
              <span>￥{{this.price}}</span>（审图意见预估：
              <span>3天</span>）
            </div>
          </div>
        </div>
        <div class="textarea">
          <div class="textarea_title">简要说明</div>
          <div class="textarea_content">
            <textarea placeholder="请输入项目简要说明" v-model="briefDescription"></textarea>
          </div>
        </div>
        <div class="upload_img">
          <div class="local_images">实地照片</div>
          <p>请上传多张实地照片，以便我们更好的了解到现场的情况</p>
          <ul>
            <li v-for="(item,index) in images" :key="index">
              <div @click="remove(index)"></div>
              <img :src="item" alt />
            </li>
            <li class="upload">
              <input type="file" id="file" accept="image/*" multiple @change="getCamera($event)" />
            </li>
          </ul>
        </div>
      </div>
      <List v-show="list" @list="getList"></List>
      <Site v-show="site" @site="getSites"></Site>
      <Address v-show="adress" @addressList="getAdress"></Address>

      <!-- 透明弹出框 -->
      <div class="tips" v-show="charge" @touchmove.prevent>
        <div class="charge_box">
          <div class="charge_children">
            <div class="charge_title">收费标准</div>
            <ul class="charge">
              <li>
                <div class="charge_name">商业场所</div>
                <div class="charge_price">
                  <div>
                    <span class="front">≤500m²</span>
                    <span class="back">￥1000</span>
                  </div>
                  <div>
                    <span class="front">500m²-1000m²内</span>
                    <span class="back">￥1500</span>
                  </div>
                  <div>
                    <span class="front">>1000m²</span>
                    <span class="back">单独计算</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="charge_name">办公场所</div>
                <div class="charge_price">
                  <div>
                    <span class="front">≤1000m²</span>
                    <span class="back">￥1000</span>
                  </div>
                  <div>
                    <span class="front">1000m²-2000m²内</span>
                    <span class="back">￥1500</span>
                  </div>
                  <div>
                    <span class="front">>2000m²</span>
                    <span class="back">单独计算</span>
                  </div>
                </div>
              </li>
            </ul>
            <div class="charge_close">
              <div class="close" @click="hideCharge"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 回到顶部 -->
      <div id="top" @click="toTop"></div>

      <!-- 提交成功 -->
      <div class="success" v-show="sucess" @touchmove.prevent>
        <div class="success_box">
          <div class="success_img">
            <div class="imgs"></div>
            <p class="success_res">提交成功</p>
            <p class="success_tap">您的审图项目已超出可估面积 平台需另外评估预算</p>

            <p class="tel">
              预算结果会以短信形式通知您 客服热线：
              <span>400-1919-119</span>
            </p>
          </div>

          <div class="close" @click="closeSucess">
            <div></div>
          </div>
        </div>
      </div>
    </section>
    <div class="foot">
      <!-- <footBottom></footBottom> -->
      <div class="button">
        <mt-button :class="{'opcity':Isubmit}" type="danger" :disabled="disable" @click="submitInput">提交</mt-button>
      </div>
    </div>
  </div>
</template>
<script>
import headTop from './header'
import footBottom from './footer'
import List from '../components/classification'
import Site from '../components/project_Site'
import Address from '../components/adress_list'
import Utils from '../utils/utils'

export default {
  name: 'online',
  data () {
    return {
      charge: false,
      list: false,
      site: false,
      adress: false,
      EntityName: '', // 单位名称
      projectName: '', // 项目名称
      projectAdress: '', // 地址信息
      inforDetial: '', // 详细地址
      projectSite: '', // 项目场所
      classification: '', // 项目类别
      projectArea: null, // 项目面积
      briefDescription: '', // 简要说明
      fileList: [],
      images: [],
      sucess: false,
      price: 0,
      disable: true,
      url: Utils.SERVER1
    }
  },
  methods: {
    chargeShow () { // 显示收费标准
      this.charge = true
      document.querySelector('body').style = 'overflow:hidden'
    },
    hideCharge () { // 关闭收费标准
      this.charge = false
      document.querySelector('body').style = 'overflow:auto'
    },
    setsite () { // 设置项目场所可见
      this.site = true
      document.querySelector('body').style = 'overflow:hidden'
    },
    setadress () { // 设置地址可见
      this.adress = true
      document.querySelector('body').style = 'overflow:hidden'
    },
    project () { // 设置项目类别可见
      this.list = true
      document.querySelector('body').style = 'overflow:hidden'
    },

    getList (k, v) { // 获取项目类别
      this.list = k
      this.classification = v
      document.querySelector('body').style = 'overflow:auto'
    },
    getSites (k, v) { // 获取项目场所信息
      this.site = k
      this.projectSite = v
      document.querySelector('body').style = 'overflow:auto'
    },
    getAdress (bool, privince, city, district) {
      this.adress = bool
      this.projectAdress = `${privince} ${city} ${district}`
      document.querySelector('body').style = 'overflow:auto'
    },
    toTop () { // 滚动至顶部
      // document.documentElement.scrollTop=0
      document.documentElement.scrollTop = document.body.scrollTop = 0
    },
    getCamera (e) {
      let _this = this
      console.log(e)
      let files = e.target.files || e.dataTransfer.files // 获取图片路径
      Array.prototype.push.apply(_this.fileList, files)
      console.log(_this.images.length)
      console.log(_this.fileList)
      console.log(_this.fileList.length)
      for (let i = 0; i < _this.fileList.length; i++) {
        let reader = new FileReader()
        reader.readAsDataURL(_this.fileList[i])
        console.log(_this.fileList[i])
        reader.onload = function () {
          _this.images.push(reader.result)
          console.log(_this.images.length)
        }
      }
      // var fr = new FileReader()// 创建new FileReader()对象
      // var imgObj = e.target.files[0]// 获取图片长度
      // fr.readAsDataURL(imgObj)// 将图片读取为DataUR
      // var that = this
      // fr.onload = function () {
      //   that.images.push(this.result) // 加入数组进行图片展
      // }
    },
    dataURLtoBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },

    closeSucess () {
      this.sucess = false
      document.querySelector('body').style = 'overflow:auto'
    },
    remove (index) {
      let _this = this
      _this.images.splice(index, 1)
      console.log(_this.images)
      _this.fileList.splice(index, 1)
      console.log(_this.fileList)
      // this.$delete(this.images, index)
    },
    loseblur (e) {
      e.srcElement.blur()
    },
    uploadImage (file) {
      let url = `${this.accountUrl}/kindeditor/upload_json_qiniu`
      // let url = `http://192.168.110.234:8080/kindeditor/upload_json_qiniu`
      let that = this
      this.images.map((item, index) => {
        let param = new FormData()
        param.append('imgFile', item)
        that.axios({
          // baseURL:"http://192.168.110.234:8010/",
          method: 'post',
          url: url,
          headers: {
            'content-type': 'multipart/form-data'
          },
          data: param
        }).then(res => {
          console.log(res)
        }).catch(err => {
          console.log(err)
        })
      })
    },
    formItem () {
      let url = `${this.accountUrl}/kindeditor/upload_json_qiniu`
      // let url = `http://192.168.110.234:8080/project/save`
      let param = new FormData()
      param.append('ent_name', this.EntityName)
      param.append('project_name', this.projectName)
      param.append('project_area', this.projectAdress)
      param.append('project_add', this.inforDetial)
      param.append('project_type', this.projectSite)
      param.append('project_style', this.classification)
      param.append('project_description', this.briefDescription)
      param.append('project_acreage', this.projectArea)
      return this.axios({
        method: 'post',
        url: url,
        headers: {
          'content-type': 'multipart/form-data'
        },
        data: param
      })
    },
    async submitInput () {
      if (this.images.length > 0) {
        await this.uploadImage()
      }

      await this.formItem().then((result) => {
        this.sucess = true
        document.querySelector('body').style = 'overflow:hidden'
        console.log('上传表单元素返回数据')
        console.log(result)
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  computed: {
    area () {
      let that = this
      if (this.projectArea == null || this.projectArea === '' || this.projectArea === 0) {
        return false
      } else {
        if (this.projectSite === '写字楼、办公楼') {
          if (this.projectArea <= 1000) {
            that.price = 1000
            return true
          } else if (this.projectArea > 1000 && this.projectArea < 2000) {
            that.price = 1500
            return true
          } else {
            return false
          }
        }
        if (this.projectSite === '休闲娱乐场所' || this.projectSite === '商业中心' || this.projectSite === '沿街商铺') {
          if (this.projectArea <= 500) {
            that.price = 1000
            return true
          } else if (this.projectArea > 500 && this.projectArea < 1000) {
            that.price = 1500
            return true
          } else {
            return false
          }
        }
      }
    },
    Isubmit () {
      let that = this
      if (this.EntityName !== '' && this.projectName !== '' && this.projectAdress !== '' && this.inforDetial !== '' && this.projectSite !== '' && this.classification !== '' && this.projectArea > 0) {
        // this.disable = false
        that.disable = false
        return true
      } else {
        that.disable = true
      }
    }
  },
  mounted () {
    this.$refs.online_contain.scrollTop = 0
  },
  components: {
    headTop,
    footBottom,
    List,
    Site,
    Address
  }
}

</script>
 <style scoped lang="scss">
.Router {
  background: #f6f3f7;
}
.header {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
}
section {
  background: #ffffff;
  margin-bottom: 10px;
}
.onlinemapping {
  background: #ffffff;
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 14px 0 15px;
  box-sizing: border-box;
  margin-top: 55px;
  margin-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
}
.onlinemapping .mapping {
  font-weight: bolder;
  font-size: 15px;
  color: #000;
  font-family: " MicrosoftYaHei-Bold ";
}
.onlinemapping .apply {
  font-weight: bolder;
  font-size: 12px;
  color: #000;
  font-family: " MicrosoftYaHei-Bold ";
}
.onlinemapping div {
  height: 30px;
  line-height: 30px;
  float: right;
  background: none;
  border: none;
  margin-top: 10px;
  color: #c41a34;
}

/*表单区域 */
.form {
  width: 100%;
  padding-left: 15px;
}
.form_list {
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  display: -webkit-flex;
  .lable {
    height: 50px;
    line-height: 50px;
    flex: 1.7;
    -webkit-flex: 1.7;
    font-size: 14px;
    color: #333333;
  }

  .text {
    flex: 8;
    -webkit-flex: 8;
    height: 30px;
    padding-left: 38.5px;
    box-sizing: border-box;
    color: #bebebe;
    margin-top: 10px;
    position: relative;
    input {
      border: none;
      outline: none;
      width: 80%;
      height: 30px;
      position: absolute;
      color: #000000;
    }
    input::-webkit-input-placeholder {
      color: #bebebe;
    }
    .arrow {
      width: 30px;
      height: 30px;
      float: right;
      background: url("../assets/next.png") no-repeat center center;
      background-size: 6px 11px;
    }
  }
}
.adress {
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #eeeeee;
  .detial_adress {
    float: left;
    width: 20%;
    font-size: 14px;
    height: 80px;
    padding: 10px 0;
    box-sizing: border-box;
    color: #333333;
  }
  .adress_content {
    float: left;
    width: 80%;
    textarea {
      width: 100%;
      height: 75px;
      outline: none;
      border: none;
      padding: 10px 10px 10px 20px;
      box-sizing: border-box;
      color: #000000;
    }
    textarea::-webkit-input-placeholder {
      color: #bebebe;
    }
  }
}
.area {
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  .area-box {
    width: 100%;
    height: 50px;
    .title {
      float: left;
      width: 20%;
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      color: #333;
    }
    .content {
      float: left;
      width: 80%;
      height: 50px;
      box-sizing: border-box;
      input {
        width: calc(100% - 33px);
        height: 30px;
        border: none;
        outline: none;
        padding-left: 20px;
        box-sizing: border-box;
        margin-top: 10px;
        color: #000000;
      }
      input::-webkit-input-placeholder {
        color: #bebebe;
      }
    }
  }
  .area-content {
    width: 100%;
    min-height: 50px;
    p {
      font-family: " SourceHanSansCN-Regular ";
      line-height: 20px;
      font-size: 12px;
      color: #808080;
      .GT {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 1px solid #c41a34;
        font-style: initial;
        line-height: 12px;
        text-align: center;
        font-size: 12px;
        color: #c41a34;
        vertical-align: text-top;
        margin: 2px 5px 0 0;
      }
      span {
        color: #c41a34;
      }
    }
    div {
      width: 100%;
      height: 25px;
      line-height: 25px;
      background: #eeeeee;
      margin: 15px auto;
      text-indent: 1em;
      span {
        color: #c41335;
        font-weight: 700;
      }
    }
  }
}
.textarea {
  width: 100%;
  height: 76px;
  // line-height: 76px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  .textarea_title {
    padding: 10px 0;
    box-sizing: border-box;
    font-size: 14px;
    color: #333;
    vertical-align: text-top;
    flex: 1.7;
    height: 76px;
  }
  .textarea_content {
    flex: 8;
    textarea {
      width: 240px;
      height: 50px;
      border: none;
      outline: none;
      margin: 10px auto 10px 30px;
      // padding: 10px 10px 10px 20px;
      color: #000000;
      overflow-y: auto;
    }
  }
}
.upload_img {
  width: 100%;
  padding-bottom: 20px;
  .local_images {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #333;
  }
  p {
    line-height: 12px;
    color: #bebebe;
    font-size: 12px;
  }
  ul {
    display: inline-block;
    padding: 0;
    min-height: 50px;
    li {
      list-style: none;
      height: 50px;
      width: 50px;
      float: left;
      margin-right: 10px;
      margin-top: 10px;
      position: relative;
      div {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0;
        right: 0;
        background: url("../assets/icon-close.png") no-repeat center center;
        background-size: 100%;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
    .upload {
      background: url("../assets/addphoto.png") no-repeat center center;
      background-size: 100%;
      input {
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }
}

.tips {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  .charge_box {
    position: fixed;
    width: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .charge_children {
      border-radius: 5px;
      overflow: hidden;
      .charge_title {
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: center;
        background: #c41335;
        color: #fff;
        font-size: 14px;
      }
      ul {
        width: 100%;
        height: 235px;
        background: #fff;
        border-radius: 0 0 5px 5px;
        padding: 15px;
        box-sizing: border-box;
        li {
          list-style: none;
          width: 100%;
          height: 96px;
          margin-bottom: 15px;
          .charge_name {
            float: left;
            width: 25%;
            height: 96px;
            line-height: 96px;
            text-align: center;
            background: #eeeeee;
            font-weight: bold;
          }
          .charge_price {
            border: 1px solid #eeeeee;
            width: 75%;
            height: 96px;
            float: left;
            box-sizing: border-box;
            .front {
              display: inline-block;
              width: 106px;
              margin-right: 20px;
              font-size: 12px;
              color: #000000;
            }
            .back {
              display: inline-block;
              line-height: 32px;
              width: 50px;
              color: #c41335;
              font-size: 12px;
            }
            div {
              width: 100%;
              line-height: 32px;
              padding: 0 10px 0 10px;
              border-bottom: 1px solid #eeeeee;
            }
            div:last-child {
              border-bottom: none;
            }
          }
        }
      }
      .charge_close {
        width: 100%;
        height: 28px;
        text-align: center;
        margin-top: 10px;
        position: relative;
        .close {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          position: absolute;
          left: 50%;
          margin-left: -14px;
          overflow: hidden;
          background: url("../assets/close.png") no-repeat center center;
          background-size: 100%;
        }
      }
    }
  }
}

.scroll {
  overflow: hidden;
}
#top {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: url("../assets/icon-top.png") no-repeat center center;
  background-size: 100%;
  position: fixed;
  right: 15px;
  bottom: 76px;
  z-index: 100;
}
.success {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 2000;
  .success_box {
    width: 80%;
    height: 280px;
    position: fixed;
    background: #ffffff;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 2000;
    .success_img {
      height: 251px;
      .imgs {
        width: 100%;
        height: 50px;
        background: url("../assets/success.png") no-repeat center center;
        background-size: 50px 50px;
        margin-top: 30px;
      }
      .success_res {
        color: #4bae4f;
        font-size: 20px;
        text-align: center;
        margin-top: 15px;
        font-weight: bold;
      }
      .success_tap {
        width: 80%;
        margin: auto;
        line-height: 25px;
        font-size: 16px;
        text-align: center;
        font-weight: bold;
        margin: 15px auto;
      }
      .tel {
        width: 80%;
        margin: auto;
        line-height: 25px;
        font-size: 16px;
        text-align: center;
        color: #808080;
        span {
          color: #c41335;
        }
      }
    }
  }
  .close {
    width: 100%;
    height: 28px;
    position: relative;
    margin-top: 20px;
    div {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      margin-left: -14px;
      background: url("../assets/close.png") no-repeat center center;
      background-size: 100%;
    }
  }
}
.foot {
  text-align: center;
  padding: 10px 15px 10px 15px;
  box-sizing: border-box;
  background: #ffffff;
  .button {
    button {
      opacity: 0.5;
    }
    .opcity {
      opacity: 1 !important;
    }
  }

  .mint-button {
    width: 100%;
    height: 45px;
    // margin: 20px auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/online-mapping-edit.vue